var _a;
export var KareoNoteStatus;
(function (KareoNoteStatus) {
    KareoNoteStatus["completed"] = "completed";
    KareoNoteStatus["incomplete"] = "incomplete";
})(KareoNoteStatus || (KareoNoteStatus = {}));
export var kareoNoteStatusLabels = (_a = {},
    _a[KareoNoteStatus.completed] = 'Complete',
    _a[KareoNoteStatus.incomplete] = 'Incomplete',
    _a);
